export const SCHEDULE_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSe1MRktZaiStfdM_ZhhGb_PnV1yeT_xgtyA4V4cRxXu4U_ptQ/viewform?usp=sf_link"

export const ASK_URL = "mailto:julie@jalactation.com"



// WEBPACK FOOTER //
// ./src/lib/urls.js